const TIPS = [
    {
        title: "First burn",
        body: "Allow the wax to melt all the way to the edges of the vessel on the first burn — this prevents tunnelling and ensures an even pool for every subsequent burn.",
    },
    {
        title: "Trim the wick",
        body: "Before each use, trim your wick to 5mm. A shorter wick produces a cleaner, steadier flame and prevents soot from forming on the glass.",
    },
    {
        title: "Burn time",
        body: "Burn for no more than 4 hours at a time. Extended burns cause the wick to mushroom and can overheat the vessel.",
    },
    {
        title: "Safe placement",
        body: "Keep candles away from draughts, curtains, and flammable materials. Always place on a heat-resistant surface and never leave burning unattended.",
    },
    {
        title: "Extinguishing",
        body: "Use a snuffer or gently dip the wick into the wax pool to extinguish — this eliminates smoke and keeps the wick primed for the next burn.",
    },
    {
        title: "Repurposing the vessel",
        body: "Once only 1cm of wax remains, discontinue use. Place the vessel in the freezer for an hour, then pop out the remaining wax and hand-wash the glass for reuse.",
    },
];

export function CandleCarePage() {
    return (
        <div className="min-h-screen pt-40 pb-24">
            <div className="max-w-3xl mx-auto px-6">
                <div className="mb-16">
                    <p className="uppercase tracking-[0.3em] text-sm text-stone-400 mb-4 font-light">Make it last</p>
                    <h1 className="font-serif text-5xl md:text-7xl font-light italic">Candle Care</h1>
                </div>
                <div className="space-y-10">
                    {TIPS.map((tip) => (
                        <div key={tip.title} className="border-t border-stone-100 pt-8">
                            <h2 className="font-serif text-xl font-light italic text-stone-900 mb-2">{tip.title}</h2>
                            <p className="text-sm text-stone-600 font-light leading-relaxed">{tip.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
